import { Component } from '@angular/core';

@Component({
  selector: 'app-hub-statistics',
  imports: [],
  templateUrl: './hub-statistics.component.html',
  styleUrl: './hub-statistics.component.css'
})
export class HubStatisticsComponent {

}
